<template style="padding-left:100px;" id="changepass">
  <div class="cpassword-container">
    <div class="d-flex w-100 m-auto p-3 justify-content-center flex-column cpassword">
      <h2>Change Password</h2>
      <!--Alert Message-->
      <ul  style="list-style: none;  padding-left: 0;" v-show="updateMsgComp !=='Password updated successfully, please logout and re login.'">
        <li  v-bind:class="{ is_valid : contains_eight_characters, is_not_valid: !contains_eight_characters }">Min 8 Characters</li>
        <li  v-bind:class="{ is_valid: contains_number, is_not_valid: !contains_number }">Contains Number</li>
        <li  v-bind:class="{ is_valid: contains_uppercase, is_not_valid: !contains_uppercase }">Contains Uppercase</li>
        <li  v-bind:class="{ is_valid: contains_lowercase, is_not_valid: !contains_lowercase }">Contains Lowercase</li>
        <li  v-bind:class="{ is_valid: contains_special_character, is_not_valid: !contains_special_character }">Contains Special Character</li>
      </ul>

      <div class="alert alert-danger" v-if="isSamePassword">New Password and Old Password are Same</div>
      <div class="alert alert-danger" v-if="isConfirmPassword">New Password and Confirm Password are Not Same</div>

      <div :class="msgClass" v-if="updateMsgComp">{{ updateMsgComp }}</div>

      <form action="#" method="post">
        <div class="form-group">
          <label class="float-left">Old Password</label>
          <input type="password" class="form-control"
                 id="" aria-describedby="emailHelp"
                 v-model="oldPassword"
                 ref="oldPassword"
                 required
                 placeholder="*Old password">
        </div>
        <div class="form-group">
          <label class="float-left">New Password</label>
          <input type="password" class="form-control"
                 id="" aria-describedby="emailHelp"
                 v-model="newPassword"
                 ref="newPassword"
                 required
                 placeholder="*New password">
        </div>
        <div class="form-group">
          <label class="float-left">Confirm New Password</label>
          <input type="password" class="form-control"
                 id="" aria-describedby="emailHelp"
                 v-model="confirmPass"
                 ref="confirmPass"
                 required
                 placeholder="*Confirm new password">
        </div>
        <div class="d-flex justify-content-end">
          <button type="button" v-on:click="changePass()" class="btn btn-success mx-3" :disabled="isDisabled">
            Change Password
          </button>
          <button type="reset" class="btn btn-info mx-3">Reset</button>
          <button v-show="!$store.state.user.enforcePasswordReset" type="reset" v-on:click="cancel()" class="btn btn-warning"> Cancel</button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'changepass',
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      confirmPass: null,
      changePassFailed: false,
      checkingConfirmPass: false,
      updateMsg: null,
      msgClass: null,
    }
  },
  computed: {
    contains_eight_characters() {
      return this.newPassword && this.newPassword.length >= 8
    },
    contains_number() {
      return this.newPassword && /\d/.test(this.newPassword)
    },
    contains_uppercase() {
      return this.newPassword && /[A-Z]/.test(this.newPassword)
    },
    contains_lowercase() {
      return this.newPassword && /[a-z]/.test(this.newPassword)
    },
    contains_special_character() {
      const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/;
      return this.newPassword && format.test(this.newPassword)
    },
    valid_password() {
      return this.contains_eight_characters && this.contains_number
          && this.contains_uppercase && this.contains_special_character && this.contains_lowercase
    },
    isSamePassword() {
      return this.oldPassword && this.newPassword && this.oldPassword === this.newPassword
    },
    isConfirmPassword() {
      return this.newPassword && this.newPassword !== this.confirmPass
    },

    isDisabled() {
      return !this.valid_password || this.isSamePassword || this.isConfirmPassword
    },
    updateMsgComp(){
      return this.updateMsg
    }
  },
  created: function () {
  },
  methods: {
    async cancel(){
      this.$router.push('/')
    },
    async changePass() {

      if (this.isDisabled) {
        return;
      }

      this.updateMsg = null

      try {

        await axios.post(`/auth/change-password`, {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        })

        this.msgClass = 'alert alert-success'
        this.updateMsg = 'Password updated successfully, please logout and re login.'

        setTimeout(function () {
          window.location.href = '#/logout'
          window.location.reload()
        }, 2000);

      } catch (error) {
 // console.error("Password update failed",error.response)
        this.updateMsg = error.response && error.response.data ?  error.response.data.error + ' Change Password Failed' : 'Change Password Failed'
        this.msgClass = 'alert alert-danger'

      }

      this.oldPassword = ""
      this.newPassword = ""
      this.confirmPass = ""

    }
  }
}
</script>
<style scoped>
.cpassword-container {
  display: flex;
  width: 100vh;
  height: 75vh;
  justify-content: center;
  align-content: center;
  align-items: center;
  align-self: center;
  padding-top: 50px;
}

.cpassword {
  box-shadow: 1px 2px 2px 3px #a7aeaa;
}

.is_valid {
  color: green
}

.is_not_valid {
  color: red
}

.btn.btn[disabled] {
  color: black;
}
</style>